import { docTypes } from 'utils/constants';

const optionalDocuments = [
    'distributorArgument',
    'regulatoryPack',
    'distributorImage',
    'brochureAMF',
    'advisorPresentation',
    'customerPresentation',
];

export const updateInvestmentFundDocs = payload => {
    let docPayload = {};

    optionalDocuments.forEach(document => {
        if (!payload[document]?.id && payload[document]) {
            const formData = new FormData();
            if (!payload[`${document}Id`]) {
                formData.append('files[]', payload[document]);
            } else {
                formData.append('file', payload[document]);
            }
            formData.append('type', docTypes.INVESTMENT_FUND);
            formData.append('subtype', 'fund_document');
            docPayload[document] = formData;
        }
    });

    return docPayload;
};

export const deleteInvestmentFundDocs = (payload, patchPayload) => {
    const newPayload = { ...patchPayload };
    optionalDocuments.forEach(document => {
        if (!payload[document]) {
            newPayload[document] = null;
        }
    });
    return newPayload;
};
